import { Slice, createSlice } from "@reduxjs/toolkit";
import { fetchEmissionTable } from "../thunk/EmissionperformanceThunk";

const initialData: any = [];

const SummaryViewSlice: Slice<any, {}, "SummaryViewSlice"> = createSlice({
    name: "SummaryViewSlice",
    initialState: { data: initialData, isLoading: false, error: "" },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchEmissionTable.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(fetchEmissionTable.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        });
        builder.addCase(fetchEmissionTable.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message ?? ""
        });
    }
})

export default SummaryViewSlice
